// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w_d8","colBig":"styles_colBig__z3mW9","colSmall":"styles_colSmall__1aeiP"};